import SystemNotificationItem from './containers/SystemNotificationItemContainer'

export default SystemNotificationItem
